import * as Mustache from 'mustache';
class Clean {
    constructor(context) {
        for (const [key, value] of Object.entries(context)) {
            if (typeof value === 'number' && !isNaN(value)) {
                Object.defineProperty(this, key, { value, enumerable: true });
            }
            else if (typeof value === 'string') {
                Object.defineProperty(this, key, { value, enumerable: true });
            }
            else if (typeof value !== 'object' || value === null) {
                continue;
            }
            else if (typeof value[Symbol.toPrimitive] === 'function') {
                Object.defineProperty(this, key, { value: value[Symbol.toPrimitive](), enumerable: true });
            }
            else if (!Array.isArray(value)) {
                Object.defineProperty(this, key, { value: new Clean(value), enumerable: true });
            }
        }
        Object.defineProperty(this, 'toString', { get: () => () => '' });
    }
}
export function render(template, context) {
    const cleaned = new Clean(context);
    return Mustache.render(`${template}`, cleaned);
}
export default render;
//# sourceMappingURL=render.js.map